import React from 'react';
import { Navigate } from 'react-router-dom';
import { useFirebaseAuth } from '../context/FirebaseAuthContext';
import { hasPermission, getUserRole } from '../utils/roles';

const RoleProtectedRoute = ({ children, requiredPermission }) => {
  const { user, loading } = useFirebaseAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  const userRole = getUserRole(user);
  const hasAccess = hasPermission(userRole, requiredPermission);

  if (!hasAccess) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full text-center">
          <h2 className="text-2xl font-bold text-red-600 mb-4">Access Denied</h2>
          <p className="text-gray-600 mb-4">
            You don't have permission to access this page.
          </p>
          <p className="text-sm text-gray-500 mb-4">
            Your role: <span className="font-semibold">{userRole}</span>
          </p>
          <p className="text-sm text-gray-500">
            Contact your administrator for access.
          </p>
        </div>
      </div>
    );
  }

  return children;
};

export default RoleProtectedRoute;


